import { render, staticRenderFns } from "./income-station.vue?vue&type=template&id=33d3af33&scoped=true&"
import script from "./income-station.vue?vue&type=script&lang=js&"
export * from "./income-station.vue?vue&type=script&lang=js&"
import style0 from "./income-station.vue?vue&type=style&index=0&id=33d3af33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3af33",
  null
  
)

export default component.exports